import { Networked3dWebExperienceClient } from "@mml-io/3d-web-experience-client";

import { initMmlObjectPlacement } from "./spotMmlObjectPlacement";

const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
const host = window.location.host;
const userNetworkAddress = `${protocol}//${host}/network`;
const chatNetworkAddress = `${protocol}//${host}/chat-network`;
const KT_API_URL = (window as any).KT_API_URL || "";

function getSpotAuthToken(): string | null {
  try {
    const raw = localStorage.getItem("spot-auth");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed.accessToken || !parsed.expiresAt) return null;
    if (Date.now() >= new Date(parsed.expiresAt).getTime() - 60_000) return null;
    return parsed.accessToken;
  } catch {
    return null;
  }
}

async function libraryMmlsProvider(): Promise<Array<{ id: string; name: string; publicUrl: string }>> {
  const token = getSpotAuthToken();
  if (!token || !KT_API_URL) return [];
  try {
    const res = await fetch(`${KT_API_URL}/api/mmls?limit=100`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return [];
    const data = await res.json();
    return (data.mmls || []).map((m: any) => ({ id: m.id, name: m.name, publicUrl: m.publicUrl }));
  } catch {
    return [];
  }
}

const holder = Networked3dWebExperienceClient.createFullscreenHolder();
const app = new Networked3dWebExperienceClient(holder, {
  sessionToken: (window as any).SESSION_TOKEN,
  userNetworkAddress,
  chatNetworkAddress,
  allowCustomDisplayName: true,
  avatarConfiguration: {
    allowCustomAvatars: true,
    availableAvatars: [],
    libraryMmlsProvider: KT_API_URL ? libraryMmlsProvider : undefined,
    onLogout: async () => {
      try {
        await fetch("/api/auth/logout", { method: "POST", credentials: "include" });
      } finally {
        localStorage.removeItem("spot-auth");
        window.location.href = "/";
      }
    },
  } as any,
  animationConfig: {
    airAnimationFileUrl: "./assets/models/anim_air.glb",
    idleAnimationFileUrl: "./assets/models/anim_idle.glb",
    jogAnimationFileUrl: "./assets/models/anim_jog.glb",
    sprintAnimationFileUrl: "./assets/models/anim_run.glb",
    doubleJumpAnimationFileUrl: "./assets/models/anim_double_jump.glb",
    glideAnimationFileUrl: "./assets/models/anim_glide.glb",
  },
  loadingScreen: {
    background: "linear-gradient(135deg, #F8F7F4 0%, #D1DDF1 50%, #E8EEF8 100%)",
    color: "#171717",
    title: "The Spot",
    subtitle: "Loading experience…",
  },
  environmentConfiguration: {
    skybox: {
      hdrJpgUrl: "./assets/hdr/puresky_2k.jpg",
    },
  },
  mmlDocuments: { playground: { url: `${protocol}//${host}/playground` } },
  onServerBroadcast: (broadcast: { broadcastType: string; payload: any }) => {
    if (placementSystem) placementSystem.handleBroadcast(broadcast);
  },
} as any);

const placementSystem = initMmlObjectPlacement(app as any);
app.update();
